// extracted by mini-css-extract-plugin
export default {"wrapper":"Themeswitcher_wrapper__hAvvb","switch":"Themeswitcher_switch__KCdcW","slider":"Themeswitcher_slider__-2aLV","round":"Themeswitcher_round__Ub3SQ"};